import React, { useEffect, useState } from "react";
import "./totp.scss";
import { Button, Card, Col, Input, Row, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginReq } from "../../../interfaces/user.interface";
import { loginService } from "../../../services/user.service";
import { HandleErrors } from "../../../utils/handleErrors";

const TOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false)

  const [loginReq, setLoginReq] = useState<LoginReq>({
    password: "",
    totp: "",
    username: "",
    captcha_key: ""
  });

  useEffect(() => {
    if (!location.state.loginPayload) {
      navigate('/auth/login', {replace: true})
    } 
  }, []);

  const login = async () => {
    try {
      setLoading(true)
      const res = await loginService({
        captcha_key: location.state.captchaKey,
        totp: loginReq.totp,
        payload: location.state.loginPayload
      });

      if (res.mfa_require) {
        navigate("/auth/totp", { state: loginReq });
      } else {
        localStorage.setItem("accessToken", res.access_token);
        localStorage.setItem("refreshToken", res.refresh_token);
        navigate("/panel", { replace: true });
      }
      setLoading(false)
    } catch (error) {
      HandleErrors(error);
      setLoading(false)
    }
  };

  return (
    <div className="TOTP">
      <div className="card-wrapper">
        <Card className="card">
          <Row justify={"center"}>
            <Col>
              <img src="/assets/icons/Totp.svg" alt="login" />
            </Col>
          </Row>
          <Row justify={"center"} className="title-box">
            <Col>
              <Typography className="title">
                کد دومرحله‌ای خود را وارد کنید
              </Typography>
            </Col>
          </Row>

          <div className="input-box">
            <Row>
              <Typography.Text className="title">کد تایید:</Typography.Text>
            </Row>
            <Row justify={"center"}>
              <Col xs={24}>
                <Input.OTP
                  value={loginReq.totp}
                  onChange={(e) => {
                    setLoginReq({
                      ...loginReq,
                      totp: e,
                    });
                  }}
                  onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    login();
                  }
                }}
                />
              </Col>
            </Row>
          </div>
          <Row justify={"center"}>
            <Col xs={24}>
              <Button
                onClick={login}
                className="submit-btn"
                block
                type="primary"
                loading={loading}
              >
                تایید
              </Button>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default TOTP;
